import {
  Card, Table, TableBody, TableCell, TableRow
} from '@material-ui/core';
import { CatalogueType } from 'api/query/catalogue/catalogue-type.enum';
import CatalogueLink from 'pages/catalogues/catalogue-link';
import { displaySaleType, formatDate } from 'pages/catalogues/catalogue-utils';
import React from 'react';
import { CatalogueCardProps } from './catalogue-card-props';
import './catalogue-card.scss';

/**
 * Catalogue Card
 */
export const CatalogueCard: React.FC<CatalogueCardProps> = (props) => {
  const {
    db, user, trait, catalogue, type,
  } = props;

  return (
    <Card className="sg-catalogue-card">
      <CatalogueLink
        db={db}
        user={user}
        trait={trait}
        label={catalogue.title}
        id={catalogue.id}
        type={type}
        className="wrap-and-truncate"
      />
      <Table className="sg-catalogue-card__table">
        <TableBody>
          {type === CatalogueType.Sales && (
            <TableRow>
              <TableCell className="sg-catalogue-card__table__header">sale date</TableCell>
              <TableCell className="cell sg-sales-catalogues__date" dangerouslySetInnerHTML={{ __html: formatDate(catalogue.saleStartDateDesc, catalogue.saleEndDateDesc) }} />
            </TableRow>
          )}
          <TableRow>
            <TableCell className="sg-catalogue-card__table__header">listed animals</TableCell>
            <TableCell className="cell sg-sales-catalogues__listed">{catalogue.listedAnimals}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="sg-catalogue-card__table__header">flock</TableCell>
            <TableCell className="cell sg-sales-catalogues__flock">{catalogue.flock}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="sg-catalogue-card__table__header">location</TableCell>
            <TableCell className="cell sg-sales-catalogues__location"><div className="wrap-and-truncate">{catalogue.city} {catalogue.state}</div></TableCell>
          </TableRow>
          {type === CatalogueType.Sales && (
            <TableRow>
              <TableCell className="sg-catalogue-card__table__header">sale type</TableCell>
              <TableCell className="cell sg-sales-catalogues__type">{displaySaleType(catalogue.saleTypeDesc)}</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
};
